import LocalizedString from './LocalizedString'
import localize from '../../higherOrderComponents/localize'

export default localize(LocalizedString)



// WEBPACK FOOTER //
// ./src/components/LocalizedString/index.js